/** Auth screens: brand panel (desktop) beside the task card; stacked on phones. No marketing copy — operator facts. */
import { CheckCircle2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { readRuntimeConfig } from '../../lib/runtime-config';
import { EnvBadge } from '../../shell/AppShell';

export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  const { buildSha } = readRuntimeConfig();
  return (
    <div className="wdc-auth">
      <aside className="wdc-auth__brand" aria-label="About the console">
        <div className="wd-row">
          <span className="wdc-brand__mark" aria-hidden="true">
            W
          </span>
          <span>
            <strong>Windrop</strong> <span style={{ opacity: 0.7 }}>console</span>
          </span>
        </div>
        <div>
          <p className="wdc-auth__headline">Run every lottery with evidence in hand.</p>
          <p>
            Lifecycle, draws, claims and payouts in one operator console. Outcomes are decided by the server
            and verifiable by anyone.
          </p>
          <ul className="wdc-auth__points">
            <li>
              <CheckCircle2 size={16} aria-hidden="true" /> Seed commitments and a public verifier for every
              draw
            </li>
            <li>
              <CheckCircle2 size={16} aria-hidden="true" /> Masked participant data; unmasking is
              purpose-bound and audited
            </li>
            <li>
              <CheckCircle2 size={16} aria-hidden="true" /> Two-person controls for high-value draws and
              payouts
            </li>
          </ul>
        </div>
        <div className="wdc-auth__foot">
          <EnvBadge />
          <span>Build {buildSha}</span>
        </div>
      </aside>
      <main className="wdc-auth__panel">
        <div className="wdc-auth__card">
          <div className="wdc-auth__mobile-brand">
            <span className="wdc-brand__mark" aria-hidden="true">
              W
            </span>
            <span>
              <strong>Windrop</strong> <span className="wd-muted">console</span>
            </span>
            <EnvBadge />
          </div>
          <h1>{title}</h1>
          {children}
        </div>
      </main>
    </div>
  );
}
